import { React, useState } from 'react';
import { Form, Image, Input } from 'antd';
import { Link } from 'react-router-dom';
import 'antd/dist/antd.css';
import style from './auth.module.scss';
import { CustomButton } from '../utils/Utils';
import axios from './../../config/apiConfig';
import animatedLogo from './../../img/logo.gif';
import {
  FacebookOutlined,
  GlobalOutlined,
  InstagramOutlined,
} from '@ant-design/icons'; 

const PassRecovery = () => {
  const { justifyCenter, justifyEnd, loginContainer, rememberPass } = style;
  const [userNotFound, setUserNotFound] = useState(false);
  const [reqOk, setReqOk] = useState(false);

  const onFinish = async (values) => {
    try {
      const { data } = await axios.post('/login/forgot-password', values);
      console.log(data); // eslint-disable-line
      setReqOk(true);
    } catch (error) {
      console.log(error); // eslint-disable-line
      setUserNotFound(true);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo); // eslint-disable-line
  };

  const onFieldsChange = () => {
    setUserNotFound(false);
  };

  return (
    <>
      <div className={loginContainer}>
        <div>
          <div>
            <Image preview={false} src={animatedLogo} alt="" />
          </div>
          <div>
            <h1>BIENVENIDO/A EXPO SUIZA 2024</h1>
            <div>
              {reqOk ? 
                <h2>Por favor revise el email que le enviamos a su casilla</h2>
                :
                <>
                  <h2>Recuperar contraseña</h2>
                  <Form
                    labelCol={{
                      span: 7,
                    }}
                    name="basic"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    onFieldsChange={onFieldsChange}
                  >
                    <Form.Item
                      label=""
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: 'Por favor ingrese su email',
                        },
                      ]}
                      {...(userNotFound
                        ? {
                          validateStatus: 'error',
                          help: 'Email, número de cuenta o contraseña incorrecta',
                        }
                        : '')}
                    >
                      <Input placeholder="Email" />
                    </Form.Item>

                    <Form.Item>
                      <Link to="/signPage" className={`${justifyCenter} ${rememberPass}`}>
                        ¡Ya recorde mi contraseña!
                      </Link>
                    </Form.Item>

                    <Form.Item>
                      <div className={justifyEnd}>
                        <CustomButton
                          htmlType="submit"
                          color="btnOrange"
                          size="bg"
                          content="Recuperar contraseña"
                        />
                      </div>
                    </Form.Item>
                  </Form>
                </>
              }
            </div>
            <div>
              <a
                href="https://www.instagram.com/drogueriasuiza.ok/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramOutlined />
                /DROGUERIASUIZATUC
              </a>
              <a
                href="https://facebook.com/DROGUERIASUIZA"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookOutlined />
                /DROGUERIASUIZA
              </a>
              <a
                href="http://www.dsuiza.com.ar/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <GlobalOutlined />
                WWW.DSUIZA.COM.AR
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PassRecovery;
